import { XmlRuleElement } from './xmlRuleElement.class';

export class XmlRules {
  public constructor(public ruleElements: Map<string, XmlRuleElement>) {}
}
